import { render, staticRenderFns } from "./casesDoKeep.vue?vue&type=template&id=07047528&scoped=true"
import script from "./casesDoKeep.vue?vue&type=script&lang=js"
export * from "./casesDoKeep.vue?vue&type=script&lang=js"
import style0 from "./casesDoKeep.vue?vue&type=style&index=0&id=07047528&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07047528",
  null
  
)

export default component.exports